import React from 'react';

import { CheckOutlined } from '@ant-design/icons';

import { LayoutContextProvider } from 'contexts';

import {
  CardHeader,
  CardAvatar,
  CenterWrapper,
  FocusedLayout,
  FocusedCard,
  Text,
  VerticalSpace,
} from '@brokerbay/design-components';

const ApprovalSubmittedPage = () => (
  <LayoutContextProvider entryRoute="approval-subbmitted">
    <FocusedLayout clean>
      <CenterWrapper>
        <FocusedCard variant="wide">
          <VerticalSpace>
            <CardHeader
              variant="wide"
              title="Approval Submitted!"
              icon={
                <CardAvatar
                  variant="wide"
                  theme="success"
                  icon={CheckOutlined}
                />
              }
            />
            <Text textAlign="center">
              The submitter has received a notification of your approval so they
              can continue to configure BrokerBay for your brokerage.
            </Text>
          </VerticalSpace>
        </FocusedCard>
      </CenterWrapper>
    </FocusedLayout>
  </LayoutContextProvider>
);

export default ApprovalSubmittedPage;
